// The hub's notifications: a quick word in the top right, shown by components/Toaster.js. For the
// outcome of something someone just did, and for a problem they could otherwise miss. A problem
// with a field they are looking at belongs next to that field instead.
const listeners = new Set();
let lastId = 0;

function show(tone, text) {
  const message = String(text || "").trim();
  if (!message) return;
  lastId += 1;
  const item = { id: lastId, tone, text: message };
  listeners.forEach((listener) => listener(item));
}

export const toast = {
  success: (text) => show("success", text),
  info: (text) => show("info", text),
  warn: (text) => show("warn", text),
  error: (text) => show("error", text),
};

/** Called with { id, tone, text } for each notification. Returns the way to stop. */
export function subscribeToToasts(listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
